import React, { Component, Fragment } from 'react';
import moment from 'moment';
import PropTypes from "prop-types";
import { get, postWithHeadersResponse, putWithHeadersResponse, postWithHeaders, patch, getRecipesDataByCode, formatNutritionFacts, getAllNutrientData } from '../../../server/actions'
import { MONTH, currency_symbol, URL_VERSION, MealTypes as _MealTypes, MenuOrderTypes, nutritions, category, URL_VERSION3, filterAllergensByCountry } from "../../../server/constants";
import './manageMealListCal.css';
import Modal from 'react-modal';
import NotificationSystem from 'react-notification-system';
import { _addNotificationError, _addNotification, isRegularLunchOrderType, getModuleEnum, getAccessLevelByModule, convertTwoDecimalPoint, groupBy } from "../../../server/util";
import { BeatLoader } from 'react-spinners';
import NutritionCtrl from '../Caterer/MenuMaster/nutritionCtrl';
import CustomSubmit from './../../Misc/customSubmit';
import { includes } from 'lodash';
import AllergensCtrl from '../../Misc/allergensCtrl';
import NutritioninfoNew from '../Caterer/MenuMaster/NutritionInfoNew';
const MealTypes = {
    breakfast: 'Breakfast',
    meal: 'MEAL',
    snack: 'SNACK',
    side: 'SIDE',
    holiday: 'HOLIDAY',
    dinner: 'DINNER',
    extras: 'EXTRA',
};
const MealTypesText = {
    MEAL: 'Main course',
    SNACK: 'Snack',
    BREAKFAST: 'Breakfast',
    SIDE: 'Sides',
    EXTRA: 'A La Carte ',
    DINNER: 'Dinner',
    HOLIDAY: 'Holiday'
}
let rowid = 0;
const modalStyles = {
    content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};
const infoModalStyles = {
    content: {
        overflow: 'auto',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '50%',
        height: '100%',
        maxHeight: '80vh',
        transform: 'translate(-50%, -50%)',
    }
};
let pathUrl = '';
const mealItemObj = {
    "itemId": sessionStorage.getItem('menuItemId'),
    "calcium": 0,
    "calories": 0,
    "cholestral": 0,
    "copper": 0,
    "dietaryFiber": 0,
    "folate": 0,
    "iron": 0,
    "magnesium": 0,
    "manganese": 0,
    "niacin": 0,
    "pantothenicAcid": 0,
    "phosphorous": 0,
    "potassium": 0,
    "protein": 0,
    "riboFlavin": 0,
    "saturatedFat": 0,
    "selenium": 0,
    "sodium": 0,
    "sugars": 0,
    "thiamin": 0,
    "totalCarbohydrate": 0,
    "totalFat": 0,
    "vitaminA": 0,
    "vitaminB6": 0,
    "vitaminB12": 0,
    "vitaminC": 0,
    "vitaminD": 0,
    "vitaminE": 0,
    "vitaminK": 0,
    "zinc": 0,
    "isNutrAvailable": true,
}
const styles = {
    imageStyle: {
        height: '30px',
        width: '30px',
    },
    eggImageStyle: {
        height: '30px',
        width: '20px',
    },
    fishImageStyle: {
        height: '18px',
        width: '30px',
    },
    fishStyle: {

        display: "flex", alignItems: "center", padding: '9px 6px', borderRadius: "50%", border: "none !important"
    },
    allergensButtonStyle: {
        display: "flex", alignItems: "center", padding: '5px 5px', borderRadius: "50%", border: "none !important"
    },
    eggButtonStyle: {
        display: "flex", alignItems: "center", padding: '5px 9px', borderRadius: "50%", border: "none !important"
    }
}

const allergens = filterAllergensByCountry(sessionStorage.getItem('countryCode'));
const modEnum = getModuleEnum();
class ManageExtraItemCal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            orderedMenu: [],
            itemsList: [],
            date: new Date(),
            menuItemId: 0,
            menuItemRec: JSON.parse(JSON.stringify(mealItemObj)),
            showCalendar: false,
            pdfLink: '',
            selectedDate: moment(),
            menuItemModalIsOpen: false,
            menuItemModalDelIsOpen: false,
            nutritionInfoIsOpen: false,
            showReasonModal: false,
            selectedMIdForDel: {
                date: '', id: 0, reason: '', title: ''
            },
            menuItem: {
                id: '0', title: '', desc: '', price: '', reducedPrice: '', start: '', type: ''
            },
            breakFastItem: {
                "itemId": 0, "itemName": "", "desc": "", "price": 0, "breakfastDate": "", "operationCode": 0
            },
            row: this.props.row,
            nutritionCodeVal: {},
            nutritionVal: [],
            servings: {},
            nutritonMasterList: []
        }
        this._notificationSystem = null;
        this.loadMenu = this.loadMenu.bind(this);
        this.loadBreakfast = this.loadBreakfast.bind(this);
        this.buildCalender = this.buildCalender.bind(this);

        this.showItemEditOpen = this.showItemEditOpen.bind(this);
        this.showNutritionInfoOpen = this.showNutritionInfoOpen.bind(this);
        this.hideshowNutritionInfoOpen = this.hideshowNutritionInfoOpen.bind(this);
        this.hideItemEditOpen = this.hideItemEditOpen.bind(this);
        this.saveNutritionInfo = this.saveNutritionInfo.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleOnChangeDecimal = this.handleOnChangeDecimal.bind(this);
        this.onSubmitForm = this.onSubmitForm.bind(this);
        this.handleOnChangeReason = this.handleOnChangeReason.bind(this);
        this.onSubmitForDel = this.onSubmitForDel.bind(this);
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        this.getNutritionMasterList();
    }
    componentWillMount = () => {
        if (this.props.type === 'MENU') {
            rowid = this.props.row.original.id; //this.props.row.original._links.self.href.split('/').pop();
            this.loadMenu(this.props.row)
        }
        else if (this.props.type === _MealTypes.BREAKFAST.toUpperCase()) {
            rowid = this.props.row.original.id;//this.props.row.original._links.self.href.split('/').pop();
            this.loadBreakfast(this.props.row)
        }
        const { id } = this.context.router.route.match.params;
        let _menuItemId = 0;
        try {
            if (parseInt(id) > 0) {
                _menuItemId = parseInt(id)
            }
        } catch (ex) {
        }
        this.setState({ menuItemId: _menuItemId }, () => {
            if (_menuItemId > 0) {
                this.getNutritionInfo();
            }
        });
    }
    componentWillReceiveProps = (nextProps) => {
        this.setState({ row: nextProps.row }, () => {
            this.loadMenu(nextProps.row);
            if (this.state.menuItemId > 0) {
                this.getNutritionInfo();
            }
        });
    }
    showItemEditOpen = (_menuItem) => {
        this.setState({ menuItem: _menuItem, menuItemModalIsOpen: true })
    }
    showNutritionInfoOpen = (_menuItem) => {
        this.setState({ menuItem: _menuItem, nutritionInfoIsOpen: true })
    }
    hideshowNutritionInfoOpen = () => {
        this.setState({ nutritionInfoIsOpen: false }, () => {
            this.loadMenu(this.props.row);
            if (this.state.menuItemId > 0) {
                this.getNutritionInfo();
            }
        })
    }
    hideItemEditOpen = () => {
        this.setState({ menuItem: { id: '0', title: '', desc: '', price: '', reducedPrice: '', start: '' }, menuItemModalIsOpen: false })
    }
    handleDecimalsOnValue(value) {
        const regex = /([0-9]*[\.]{0,1}[0-9]{0,2})/;
        return value.match(regex)[0];
    }
    handleOnChangeDecimal = (e) => {
        let _menuItem = this.state.menuItem;
        _menuItem[e.currentTarget.name] = this.handleDecimalsOnValue(e.currentTarget.value);
        this.setState({ menuItem: _menuItem });
    }
    handleOnChange = (e) => {
        let _menuItem = this.state.menuItem;
        _menuItem[e.currentTarget.name] = e.currentTarget.value;
        this.setState({ menuItem: _menuItem });
    }
    handleOnChangeReason = (e) => {
        let _delReason = this.state.selectedMIdForDel;
        _delReason[e.currentTarget.name] = e.currentTarget.value;
        this.setState({ selectedMIdForDel: _delReason });
    }
    getMealType = () => {
        const { itemsList } = this.state;
        const type = itemsList;
        if (this.props.mealType === _MealTypes.LUNCH) {
            if (this.state.menuItem.type === MealTypes.holiday) {
                return this.state.menuItem.type
            }
            return ((isRegularLunchOrderType() ? MealTypes.extras : MenuOrderTypes.ITEMIZE) || '').toUpperCase()

            /*  if (type===MealTypes.extras){
                return ((isRegularLunchOrderType()?MealTypes.extras:MenuOrderTypes.ITEMIZE)||'').toUpperCase()
            } */
        }
        else {
            if (this.state.menuItem.type === MealTypes.holiday) {
                return this.state.menuItem.type
            } else {
                return ((isRegularLunchOrderType() ? MealTypes.extras : MenuOrderTypes.ITEMIZE) || '').toUpperCase()

            }
        }
    }
    onSubmitForDel = (e, callback) => {
        e.preventDefault();
        let _self = this;
        let rowid = this.props.row.original.id;// this.props.row.original._links.self.href.split('/').pop();
        let _mItem = this.state.selectedMIdForDel;
        let reqObject = {}
        if (this.props.type === "MENU") {
            reqObject = {
                "operationCode": 2,
                "menuModificationDate": _mItem.date,
                "mealCalendarId": _mItem.id,
                "itemName": _mItem.title,
                "mealType": this.getMealType(),
                "deletionReason": _mItem.reason
            }
        } else {
            reqObject = {
                "operationCode": 2,
                "menuModificationDate": _mItem.date,
                "mealCalendarId": _mItem.id,
                "itemName": _mItem.title,
                //"mealType": MealTypes.,
                "deletionReason": _mItem.reason
            }
        }
        if ((_mItem.reason || '').trim() === '') {
            _addNotificationError('Please provide reason for delete meal item.', this.props.notify);
            callback(true);
            return false;
        }
        let headers = {
            'Content-Type': 'application/json'
        };
        if (this.props.type === "MENU") {
            this.setState({ loading: true });
            postWithHeadersResponse(URL_VERSION3 + '/menuItemsModification/' + rowid + '?access_token=', JSON.stringify(reqObject), headers).then((response) => {

                if (response.statusCode === 200) {
                    _addNotification('Lunch Menu has been deleted successfully.', this.props.notify);
                    callback(true);
                    this.setState({ loading: false, selectedMIdForDel: { date: '', id: 0, reason: '' }, showReasonModal: false },
                        this.props.callBackManageItems()
                    );
                } else {
                    throw Error(response.statusMessage);
                }
            }).catch(
                (error) => {
                    alert(error.message);
                    this.setState({ loading: false });
                    _addNotificationError(error.message, this.props.notify);
                    callback(true);
                    // console.log('Meal Menu Creation Error', error)
                }
            );
        } else {
            this.setState({ loading: true });
            postWithHeadersResponse(URL_VERSION3 + '/menuItemsModification/' + rowid + '?access_token=', JSON.stringify(reqObject), headers).then((response) => {

                if (response.statusCode === 200) {
                    _addNotification('Breakfast Menu has been deleted successfully.', this.props.notify);
                    callback(true);
                    this.setState({ loading: false, selectedMIdForDel: { date: '', id: 0, reason: '' }, showReasonModal: false },
                        this.props.callBackManageItems()
                    );
                } else {
                    throw Error(response.statusMessage);
                }
            }).catch(
                (error) => {
                    alert(error.message);
                    this.setState({ loading: false });
                    _addNotificationError(error.message, this.props.notify);
                    callback(true);
                    // console.log('Meal Menu Creation Error', error)
                }
            );

        }
    }
    getNutritionMasterList = async () => {
        const nutList = [];
        const res = await getAllNutrientData();
        if (!res.error) {
          const resp = res.data || [];
          resp.map(itm => {
            nutList.push({
              ...itm,
              nutrientDescriptions: [
                {
                  nutrientDescription: `${itm.nutrientDescription}`,
                  nutrientUnit: `${itm.units}`
                }
              ]
            });
            if ((itm.subNutrients || []).length > 0) {
              (itm.subNutrients || []).map(sitm => {
                nutList.push({
                  parent: itm.nutrientCode,
                  ...sitm,
                  nutrientDescriptions: [
                    {
                      nutrientDescription: `${sitm.nutrientDescription}`,
                      nutrientUnit: `${sitm.units}`
                    }
                  ]
                });
              });
            }
          })
          this.setState({nutritonMasterList: [...nutList]});
        }
      }
    getNutritionInfo = (menuItemId) => {
        this.setState({ loading: true })
        get(`/menuItems/${menuItemId}?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            let _menuItemRec = data || {};
            let _mealRec = JSON.parse(JSON.stringify({ ...mealItemObj, itemId: menuItemId }));
            _mealRec = { ..._mealRec, ..._menuItemRec }
            this.setState({ loading: false, menuItemRec: { ..._mealRec } })
            if(_mealRec.sourceRecipeId === undefined){
                this.setState({ menuItemRec: { ...this.state.menuItemRec, imageUrl:null  }, nutritionVal: [] });
            }else{
            getRecipesDataByCode(_mealRec.sourceRecipeId).then((resp) => {
                if (!resp.ok) {
                    throw Error(resp.statusText);
                }
                return resp.json();
            }).then(respData => {
                let nutritionData = [];
                nutritionData = formatNutritionFacts((this.state.nutritonMasterList || []), (respData.nutrientValues || []), true, ((respData || []).servings || {}).size || 0);
                const result = nutritionData.reduce((acc, item) => {
                    acc[item.nutrientCode] = item.nutrientValue;
                    return acc;
                }, {});
                this.setState({ menuItemRec: { ...this.state.menuItemRec, nutritionData, imageUrl:respData.imageUrl} })
                this.setState({nutritionCodeVal: {...result}});
                this.setState({nutritionVal: nutritionData});
                this.setState({servings: respData.servings});
            }).catch(
                (error) => {
                    console.log('Get Nutrition code values response', error)
                    this.setState({loading: false})
                })
            }
        }).catch(
            (error) => {
                this.setState({ loading: false })
                console.log('Get NutritionInfo response', error)
            }
        );
    }
    saveNutritionInfo = (e, callback) => {
        let _menuItemRec = this.state.menuItemRec;
        _menuItemRec['schoolDetails'] = "/mealManage/mealSchools/" + sessionStorage.getItem('SchoolId') || 0;
        this.setState({ menuItemRec: _menuItemRec })
        let _menuRec = JSON.parse(JSON.stringify(this.state.menuItemRec));
        Object.keys(nutritions).map((keyName) => {
            let _keyVal = 0
            try {
                _keyVal = (_menuRec[keyName] || 0) === '' ? 0 : parseInt((_menuRec[keyName] || 0));
            } catch (e) {
                _keyVal = 0;
            }
            if (_keyVal <= 0) {
                delete _menuRec[keyName];
            }
        })
        this.setState({ loading: true })
        let headers = {
            'Content-Type': 'application/json'
        }
        let request = _menuRec
        /*  let validate = (_menuRec.protein > 0 && _menuRec.calories > 0 && _menuRec.calcium > 0 && _menuRec.potassium > 0
             && _menuRec.cholestral > 0 && _menuRec.saturatedFat > 0 && _menuRec.totalFat > 0 && _menuRec.totalCarbohydrate > 0 &&
             _menuRec.iron > 0 && _menuRec.sugars > 0)
         if (validate) { */
        postWithHeaders(`/nutritionAudits?access_token=`, JSON.stringify(request), headers).then((response) => {
            if (response.ok) {
                this.setState({ loading: false });
                _addNotification('Nutrition Info updated successfully.', this.props.notify);
                callback(true);
                this.getNutritionInfo(_menuItemRec.itemId);
                this.hideshowNutritionInfoOpen();
            } else if (!response.ok) {
                throw Error(response.statusMessage);
            }
        }).catch(
            (error) => {
                this.setState({ loading: false })
                _addNotificationError(error.status, this.props.notify)
                callback(true);
            }
        );
        /*  }
         else {
             alert('Enter all required fields(*) info');
         } */
    }
    onSubmitForm = (e, callback) => {
        e.preventDefault();
        let rowid = this.props.row.original.id;// this.props.row.original._links.self.href.split('/').pop();
        let _url = URL_VERSION3 + '/menuItemsModification/' + rowid + '?access_token=';
        let reqObject = {};
        let headers = {
            'Content-Type': 'application/json'
        };
        if (this.state.menuItem.id == '0') {
            if (this.props.type === "MENU") {
                reqObject = {
                    "operationCode": 0,
                    "menuModificationDate": this.state.menuItem.start.format("YYYY-MM-DD"),
                    "itemName": this.state.menuItem.title,
                    "desc": this.state.menuItem.desc,
                    "mealType": this.getMealType(),
                    "price": this.state.menuItem.price,
                    "reducedPrice": this.state.menuItem.reducedPrice
                }
            } else {
                reqObject = {
                    "operationCode": 0,
                    "menuModificationDate": this.state.menuItem.start.format("YYYY-MM-DD"),
                    "itemName": this.state.menuItem.title,
                    "desc": this.state.menuItem.desc,
                    "mealType": this.getMealType(),
                    "price": this.state.menuItem.price,
                    "reducedPrice": this.state.menuItem.reducedPrice || 0
                }
            }

            if ((this.state.menuItem.title || '').trim() === '') {
                this.setState({ loading: false });
                //CustomSubmit.disable_enableBtn(true);
                _addNotificationError('Please enter item Name.', this.props.notify);
                callback(true);
                return false;
            }
            if ((this.state.menuItem.price || '').trim() === '') {
                this.setState({ loading: false });
                _addNotificationError('Please enter item price.', this.props.notify);
                callback(true);
                return false;
            }
            this.setState({ loading: true });
            postWithHeadersResponse(_url, JSON.stringify(reqObject), headers).then((response) => {
                if (response.statusCode === 200) {
                    this.setState({ loading: false });
                    _addNotification('Meal item added/updated successfully.', this.props.notify);
                    callback(true);
                    this.props.callBackManageItems();
                    this.hideItemEditOpen();
                } else {
                    throw Error(response.statusMessage);
                }
            }).catch(
                (error) => {
                    this.setState({ loading: false });
                    callback(true);
                    alert(error.message);
                }
            );
        }
        else {
            if (this.props.type === "MENU") {
                reqObject = {
                    "operationCode": 1,
                    "menuModificationDate": this.state.menuItem.date,
                    "mealCalendarId": this.state.menuItem.mealCalendarId, // this.state.menuItem.mealCalendarId,
                    "itemName": this.state.menuItem.title,
                    "desc": this.state.menuItem.desc,
                    "mealType": this.getMealType(),
                    "price": this.state.menuItem.price,
                    "reducedPrice": this.state.menuItem.reducedPrice || 0
                }
            } else {
                reqObject = {
                    "operationCode": 1,
                    "menuModificationDate": this.state.menuItem.date,
                    "mealCalendarId": this.state.menuItem.mealCalendarId, //this.state.menuItem.mealCalendarId,
                    "itemName": this.state.menuItem.title,
                    "desc": this.state.menuItem.desc,
                    "mealType": this.getMealType(),
                    "price": this.state.menuItem.price,
                    "reducedPrice": this.state.menuItem.reducedPrice || 0
                }
            }
            this.setState({ loading: true });
            postWithHeadersResponse(_url, JSON.stringify(reqObject), headers).then((response) => {
                if (response.statusCode === 200) {
                    this.setState({ loading: false });
                    _addNotification('Meal item updated successfully.', this.props.notify);
                    callback(true);
                    this.props.callBackManageItems();
                    this.hideItemEditOpen();
                } else {
                    throw Error(response.statusMessage);
                }
            }).catch(
                (error) => {
                    this.setState({ loading: false });
                    callback(true);
                    alert(error.message);
                }
            );
        }
    }
    loadMenu = (row) => {
        let id = row.original.id; //row.original._links.self.href.split('/').pop();
        get('/mealSummaryDetails?menuSummaryId=' + id + '&isViewMenu=true&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            this.setState({ extraCal: data.isExtraPreOrder, itemsList: data.menuItemsList })
            const { extraCal } = this.state
            //localStorage.setItem('isExtraPreOrder',extraCal);   
            let meals = (data.menuItemsList || []).sort((a, b) => {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            }).sort((a, b) => {
                if (a.type < b.type) {
                    return -1;
                }
                if (a.type > b.type) {
                    return 1;
                }
                return 0;
            });
            meals.forEach(event => {
                //if (event.type !== MealTypes.holiday) {
                let dt = moment(event.start, 'YYYY-MM-DD').toDate();
                event.start = dt.addHours(1);
                event.title = event.name;
                //}

            });

            let parts = row.original.month.split(' ');
            let d = new Date(parts[1], MONTH.indexOf(parts[0]))
            this.setState({ orderedMenu: meals, date: d, showCalendar: true, pdfLink: row.original.pdf });
        }).catch(error => {
            console.log("Loading Menu Failed", error)
        })
    }
    loadBreakfast = (row) => {
        let id = row.original._links.self.href.split('/').pop();
        get('/mealSummaryDetails?menuSummaryId=' + id + '&isViewMenu=true&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            let meals = (data.menuItemsList || []).sort((a, b) => {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            }).sort((a, b) => {
                if (a.type < b.type) {
                    return -1;
                }
                if (a.type > b.type) {
                    return 1;
                }
                return 0;
            });//eval('(' + data.jsonData + ')');
            meals.forEach(event => {
                // if (event.type === MealTypes.breakfast) {
                let dt = moment(event.start, 'YYYY-MM-DD').toDate();
                event.start = dt.addHours(1);
                event.title = event.name;
                //}
            });

            let parts = row.original.month.split(' ');
            let d = new Date(parts[1], MONTH.indexOf(parts[0]))
            this.setState({ orderedMenu: meals, date: d, showCalendar: true, pdfLink: row.original.pdf });
        }).catch(error => {
            console.log("Loading Menu Failed", error)
        })
    }
    loadOrderedMenu = (row, yearMonth) => {
        get('/mealOrderDetailses/search/findByStudentUserUserIdAndYearMonth?studentRecId=' + row.original.studentRecId + '&yearMonth=' + yearMonth + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            let orderId = data._links.mealOrderDetails.href.split('/').pop();
            let isEligibleForFreeMeal = data.isEligibleForFreeMeal;
            let isEligibleForReducedPrice = data.isEligibleForReducedPrice;
            if (orderId !== null && orderId !== '' && orderId !== undefined) {
                get('/mealOrderDetailses/' + orderId + '/schoolMeals?access_token=').then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    console.log('response', response);
                    return response.json();
                }).then(data => {
                    let x = [];
                    let requests = data._embedded.schoolMeals.map(meal => {
                        return new Promise((resolve) => {
                            let item = {};
                            item.id = meal._links.self.href.split('/').pop();
                            item.title = meal.mealMenu.title;
                            item.type = meal.mealMenu.type;
                            item.start = moment(meal.mealMenu.start);
                            let dateObj = meal.mealMenu.start.split(/[- : T]/);
                            item.start = new Date(dateObj[0], parseInt(dateObj[1]) - 1, dateObj[2]);
                            if (isEligibleForFreeMeal)
                                item.price = 0;
                            else if (isEligibleForReducedPrice)
                                item.price = meal.mealMenu.reducedPrice
                            else
                                item.price = meal.mealMenu.price;
                            if (meal.mealMenu.type === MealTypes.side) {
                                item.start = item.start.addHours(1);

                            }
                            x.push(item);
                            resolve();
                        });
                    })
                    Promise.all(requests).then(() => {
                        this.setState({
                            orderedMenu: x,
                            date: this.props.date,
                            showCalendar: true,
                            pdfLink: row.original.pdfLink
                        })
                    })


                }).catch(
                    (error) => {
                        console.log('Get Order History response', error)
                    }
                )
            }
        }).catch(error => {
            console.log("Error getting student order", error)
        })
    }

    buildCalender = (month, year) => {
        let firstDay = moment([parseInt(year), parseInt(month) - 1]).day();
        let daysInMonth = parseInt(moment([parseInt(year), parseInt(month) - 1]).endOf('month').format('DD'));
        let date = 1;
        console.log('orderedMenu', this.state.orderedMenu);
        return (
            <table className="table table-bordered table-responsive" id="calendar">
                <thead >
                    <tr className="bg-color-1 tblHead">
                        {
                            [0, 1, 2, 3, 4, 5, 6].map(i => {
                                return (this.props.hiddenDays || []).includes(i) ?
                                    <th className="col-lg-2" style={{ display: 'none' }}>{moment().day(i).format('ddd')}</th> :
                                    <th className="col-lg-2">{moment().day(i).format('ddd')}</th>
                            })
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        [0, 1, 2, 3, 4, 5].map((i) => {
                            return (<tr>{
                                [0, 1, 2, 3, 4, 5, 6].map((j) => {
                                    if (i === 0 && j < firstDay) {

                                        return (this.props.hiddenDays || []).includes(j) ? <td style={{ display: 'none' }}></td> : <td className="tblBodyCol">{ }</td>

                                    } else if (date > daysInMonth) {
                                        return null
                                    } else {
                                        let _todayExtrasList = [];
                                        _todayExtrasList = this.state.orderedMenu.filter(item => {
                                            return (moment(item.start).format('YYYY-MM-DD') === moment(new Date(parseInt(year), (parseInt(month) - 1), date)).format('YYYY-MM-DD') &&
                                                (item.type === MealTypes.extras || item.type == MenuOrderTypes.ITEMIZE.toUpperCase() || item.type === "HOLIDAY"))
                                                ;
                                        }).sort((a, b) => {
                                            if (a.title < b.title) {
                                                return -1;
                                            }
                                            if (a.title > b.title) {
                                                return 1;
                                            }
                                            return 0;
                                        })
                                        const groupTodayMeals = groupBy(_todayExtrasList, 'type');
                                        console.log("extra item", groupTodayMeals)
                                        let _str = (this.props.hiddenDays || []).includes(j) ? <td style={{ display: 'none' }}></td> :
                                            <td className="tblBodyCol" data-date={moment(new Date(parseInt(year), (parseInt(month) - 1), date)).format('YYYY-MM-DD')}>
                                                <span className="tblBodyColDate">{date}</span>
                                                {
                                                    ((_todayExtrasList.filter(value => value.type === MealTypes.extras || value.type == MenuOrderTypes.ITEMIZE.toUpperCase()).length > 0 ||
                                                        _todayExtrasList.filter(value => value.type === "HOLIDAY").length >= 0) &&
                                                        moment() <= moment(new Date(parseInt(year), (parseInt(month) - 1), date)))
                                                    //      &&
                                                    // <a className="pull-right color-4" style={{ fontSize: '20px' }} title="Add Extra Item" href onClick={(e) => {
                                                    //     let _date = e.currentTarget.parentElement.getAttribute("data-date");
                                                    //     let _menuItem = this.state.menuItem;
                                                    //     _menuItem.id = 0;
                                                    //     _menuItem.type = this.props.type === 'EXTRA' ? MealTypes.extras : MealTypes.breakfast
                                                    //     _menuItem.start = moment(_date);
                                                    //     this.setState({ menuItemModalIsOpen: true, menuItem: _menuItem })
                                                    // }} ><i className="fa fa-plus-square"></i></a>
                                                }


                                                {
                                                    _todayExtrasList.length > 0 ?
                                                        Object.keys(groupTodayMeals).map(keyName => {
                                                            const mealList = groupTodayMeals[keyName] || [];
                                                            //if (keyName === 'EXTRA') {
                                                                return <Fragment>
                                                                    <p className="groupTitle">
                                                                        <small>{MealTypesText[keyName]}</small>
                                                                        <hr className="menuItemDivision" />
                                                                    </p>
                                                                    {
                                                                        mealList.sort((a, b) => a.title.localeCompare(b.title)).map((fItem) => {
                                                                            const nutritionInfo = ((fItem.isNutrAvailable || '') !== '' && fItem.isNutrAvailable) ? true : false;
                                                                            return fItem.type === MealTypes.extras || fItem.type == _MealTypes.SNACK || fItem.type == _MealTypes.DINNER.toUpperCase() || fItem.type == MenuOrderTypes.ITEMIZE.toUpperCase() ?
                                                                                <div className="title label-success" style={{ backgroundColor: 'rgb(11, 86, 103)' }}>
                                                                                    <Fragment><span>{`${fItem.title} ${currency_symbol()} ${convertTwoDecimalPoint(fItem.price)}` + `${" "}`}
                                                                                        {((nutritionInfo) ?
                                                                                            <a style={{ fontSize: '15px' }} title="Nutrition Info" href onClick={(e) => {
                                                                                                console.log(fItem)
                                                                                                const menuItemId = fItem.id
                                                                                                sessionStorage.setItem('menuItemId', menuItemId)
                                                                                                this.setState({ nutritionInfoIsOpen: true, menuItem: { ...fItem } })
                                                                                                this.getNutritionInfo(menuItemId)
                                                                                            }} ><i className="fa fa-info-circle color-2"></i></a> :
                                                                                            <a style={{ fontSize: '15px' }} title="Nutrition Info N/A" href onClick={(e) => {
                                                                                                console.log(fItem)
                                                                                                const menuItemId = fItem.id
                                                                                                sessionStorage.setItem('menuItemId', menuItemId)
                                                                                                this.setState({ nutritionInfoIsOpen: true, menuItem: { ...fItem } })
                                                                                                this.getNutritionInfo(menuItemId)

                                                                                            }} ><i className="fa fa-info-circle color-3"></i></a>
                                                                                        )}
                                                                                    </span></Fragment>
                                                                                    {/* {
                                                                                        moment() <= moment(new Date(parseInt(year), (parseInt(month) - 1), date)) &&
                                                                                        <a className='edit color-2' style={{ fontSize: '17px' }} title="Edit Extra Item" href onClick={(e) => {
                                                                                            console.log(fItem)
                                                                                            this.setState({ menuItemModalIsOpen: true, menuItem: { ...fItem } })

                                                                                        }} ><i className="fa fa-pencil-square"></i></a>
                                                                                    } {
                                                                                        moment() <= moment(new Date(parseInt(year), (parseInt(month) - 1), date)) &&
                                                                                        <a className='delete color-1' style={{ fontSize: '17px' }} title="Delete Extra Item" data-id={fItem.mealCalendarId} href onClick={(e) => {
                                                                                            let _selectedMIdForDel = this.state.selectedMIdForDel;
                                                                                            _selectedMIdForDel.date = e.currentTarget.parentElement.parentElement.getAttribute("data-date");
                                                                                            _selectedMIdForDel.id = e.currentTarget.getAttribute('data-id');
                                                                                            this.setState({ menuItemModalDelIsOpen: true, selectedMIdForDel: _selectedMIdForDel });
                                                                                        }}><i className="fa fa fa-window-close"></i></a>
                                                                                    } */}
                                                                                </div>

                                                                                :
                                                                                fItem.type === MealTypes.holiday ?
                                                                                    <div className="title label-info" style={{ backgroundColor: "rgba(8, 66, 158, 0.79)" }}>
                                                                                        <span>{`${fItem.title}`}</span>
                                                                                        {/* {
                                                                                            moment() <= moment(new Date(parseInt(year), (parseInt(month) - 1), date)) &&
                                                                                            <a className='edit color-2' style={{ fontSize: '17px' }} title="Edit Menu Item" href onClick={(e) => {
                                                                                                this.setState({ menuItemModalIsOpen: true, menuItem: { ...fItem } })
                                                                                            }} ><i className="fa fa-pencil-square"></i></a>
                                                                                        }
                                                                                        {
                                                                                            moment() <= moment(new Date(parseInt(year), (parseInt(month) - 1), date)) &&
                                                                                            <a className='delete color-1' style={{ fontSize: '17px' }} title="Delete Menu Item" data-id={fItem.mealCalendarId} href onClick={(e) => {
                                                                                                let _selectedMIdForDel = this.state.selectedMIdForDel;
                                                                                                _selectedMIdForDel.date = e.currentTarget.parentElement.parentElement.getAttribute("data-date");
                                                                                                _selectedMIdForDel.id = e.currentTarget.getAttribute('data-id');
                                                                                                this.setState({ menuItemModalDelIsOpen: true, selectedMIdForDel: _selectedMIdForDel });
                                                                                            }}><i className="fa fa fa-window-close"></i></a>
                                                                                        } */}
                                                                                    </div>
                                                                                    : null

                                                                        })

                                                                    }
                                                                </Fragment>

                                                            //}
                                                        })
                                                        : null

                                                }



                                            </td>
                                        date++;
                                        return _str;

                                    }
                                })}
                            </tr>);
                        })
                    }
                </tbody>
            </table>
        )
    }
    onAllergensChange(item) {
        let _menuItemRec = this.state.menuItemRec;

        if ("allergensInfo" in _menuItemRec && _menuItemRec.allergensInfo) {
            if (!_menuItemRec.allergensInfo.includes(item)) {
                _menuItemRec.allergensInfo.push(item)
            } else {
                const index = _menuItemRec.allergensInfo.indexOf(item)
                _menuItemRec.allergensInfo.splice(index, 1)
            }
        } else {
            _menuItemRec.allergensInfo = [item]
        }
        this.setState({ menuItemRec: _menuItemRec })
    }
    render() {
        if (!this.state.showCalendar) {
            return (
                <div>
                    <h4>Loading ...</h4>
                </div>
            )
        }
        else {
            return (
                <div>
                    <NotificationSystem ref="notificationSystem" />
                    <div className="row margin-top-10 mr-bt-5 manage-order-pdf-row">

                        <div className='sweet-loading'
                            style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                            <BeatLoader
                                size={20}
                                color={'#ea7066'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="col-md-12 col-sm-12 col-xs-12"><h4
                            className="text-center color-3">{MONTH[this.state.date.getMonth()] + ' ' + this.state.date.getFullYear()}</h4>
                        </div>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="pull-right">
                                <a href={this.state.pdfLink} target="_blank" download>
                                    <button type="button"
                                        className="btn-social btn-linkedin-filled btn-rounded " style={{ border: '0px' }}>
                                        <i class="fa fa-file-pdf-o"></i> Download PDF
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="table-responsive mr-bt-10">
                        {this.buildCalender(moment(this.state.date).format('MM'), moment(this.state.date).format('YYYY'))}
                    </div>

                    <Modal isOpen={this.state.nutritionInfoIsOpen}
                                onRequestClose={() => this.setState({ nutritionInfoIsOpen: false })}
                                style={infoModalStyles}
                                contentLabel="Nutrition Info"
                            >
                                <div>
                                    <div className="modal-header">
                                        <h4 className="modal-title modal-title-color" id="deleteLabel">Nutrition Info</h4>
                                    </div>
                                    <div className="modal-body">
                                        <div className="row">
                                            <form>
                                                <div className="col-sm-12 col-md-12">
                                                    <div className="form-group">
                                                        <NutritioninfoNew nutritionCodeVal={this.state.nutritionCodeVal} data={this.state.menuItemRec} nutritionVal={this.state.nutritionVal} servings={this.state.servings} />
                                                    </div>

                                                    <div className="from-group text-right">
                                                        <button type="button" className="btn bg-color-4" onClick={(e) => {
                                                            this.hideshowNutritionInfoOpen(e);
                                                        }}>Back</button>
                                                    </div>
                                                </div>
                                            </form>

                                        </div>
                                    </div>
                                </div>
                            </Modal>

                    <Modal isOpen={this.state.menuItemModalIsOpen}
                        onRequestClose={() => this.setState({ menuItemModalIsOpen: false })}
                        style={modalStyles}
                        contentLabel="Add Menu Item"
                        ariaHideApp={false}>
                        <div>
                            <div className="modal-header">
                                <h4 className="modal-title modal-title-color" id="deleteLabel">
                                    {this.props.type === "MENU" ? "Add/Edit Menu Item" : "Add/Edit Breakfast Menu Item"}</h4>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    {
                                        this.state.menuItem.type === MealTypes.side ?
                                            <form>
                                                <div className="col-sm-12 col-md-12">
                                                    <div className="form-group">
                                                        <label className="control-label" htmlFor="county">Item
                                                            Name*</label>
                                                        <input type="text" name="title"
                                                            className="form-control border-color-1 rounded" id="title" value={this.state.menuItem.title}
                                                            placeholder="Title" onChange={(e) => { this.handleOnChange(e); }}
                                                            required />
                                                    </div>
                                                    <div className='form-group'>
                                                        <p className='text-danger'><label>Alert:</label> The menu item you added/edited is applicable to the current menu only.</p>
                                                    </div>
                                                    <div className="from-group text-right">
                                                        <CustomSubmit type="button" className="btn btn-success btn-xs"
                                                            style={{ margin: '0 0 0 5px' }}
                                                            handleSubmit={(e, callback) => this.onSubmitForm(e, callback)} >
                                                            Save
                                                        </CustomSubmit>
                                                        <button type="button" className="btn btn-primary btn-xs" onClick={(e) => {
                                                            this.hideItemEditOpen(e);
                                                        }}>Cancel</button>
                                                    </div>
                                                </div>
                                            </form>
                                            : this.state.menuItem.type === MealTypes.holiday ?
                                                <form >
                                                    <div className="col-sm-12 col-md-12">
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="county">Item
                                                                Name*</label>
                                                            <input type="text" name="title"
                                                                className="form-control border-color-1 rounded" id="title" value={this.state.menuItem.title}
                                                                placeholder="Title" onChange={(e) => { this.handleOnChange(e); }}
                                                                required />
                                                        </div>
                                                        <div className='form-group'>
                                                            <p className='text-danger'><label>Alert:</label> The menu item you added/edited is applicable to the current menu only.</p>
                                                        </div>
                                                        <div className="from-group text-right">
                                                            <CustomSubmit type="button" className="btn btn-success btn-xs"
                                                                style={{ margin: '0 0 0 5px' }}
                                                                handleSubmit={(e, callback) => this.onSubmitForm(e, callback)} >
                                                                Save
                                                            </CustomSubmit>
                                                            <button type="button" className="btn btn-primary btn-xs" onClick={(e) => {
                                                                this.hideItemEditOpen(e);
                                                            }}>Cancel</button>
                                                        </div>
                                                    </div>
                                                </form>
                                                :
                                                <form>
                                                    <div className="col-sm-12 col-md-12">
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="county">Item
                                                                Name*</label>
                                                            <input type="text" name="title"
                                                                className="form-control border-color-1 rounded" id="title" value={this.state.menuItem.title}
                                                                placeholder="Title" onChange={(e) => { this.handleOnChange(e); }}
                                                                required />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="desc">Desc. *</label>
                                                            {
                                                                parseInt(((this.state.menuItem.id) === '' ? '0' : (this.state.menuItem.id || 0))) === 0 ?
                                                                    <input type="text" multiple name="desc" value={this.state.menuItem.desc}
                                                                        className="form-control border-color-1 rounded" id="desc"
                                                                        placeholder="Description" onChange={(e) => { this.handleOnChange(e); }}
                                                                        disabled={false} required /> :
                                                                    <input type="text" multiple name="desc" value={this.state.menuItem.desc}
                                                                        className="form-control border-color-1 rounded" id="desc"
                                                                        placeholder="Description" onChange={(e) => { this.handleOnChange(e); }}
                                                                        disabled />
                                                            }

                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="district">Price ({currency_symbol()}) *</label>
                                                            {
                                                                parseInt(((this.state.menuItem.id) === '' ? '0' : (this.state.menuItem.id || 0))) === 0 ?
                                                                    <input type="text" name="price" value={this.state.menuItem.price}
                                                                        className="form-control border-color-1 rounded" id="price"
                                                                        placeholder={`Price (${currency_symbol()})`} onChange={(e) => { this.handleOnChangeDecimal(e); }}
                                                                        disabled={false} required /> :
                                                                    <input type="text" name="price" value={this.state.menuItem.price}
                                                                        className="form-control border-color-1 rounded" id="price"
                                                                        placeholder={`Price (${currency_symbol()})`} onChange={(e) => { this.handleOnChangeDecimal(e); }}
                                                                        disabled={this.props.row.original.isPublished} />
                                                            }
                                                        </div>
                                                        <div className='form-group'>
                                                            <p className='text-danger'><label>Alert:</label> The menu item you added/edited is applicable to the current menu only.</p>
                                                        </div>


                                                        <div className="from-group text-right">
                                                            <CustomSubmit type="button" className="btn btn-success btn-xs"
                                                                style={{ margin: '0 0 0 5px' }}
                                                                handleSubmit={(e, callback) => this.onSubmitForm(e, callback)} >
                                                                Save
                                                            </CustomSubmit>
                                                            <button type="button" className="btn btn-primary btn-xs" onClick={(e) => {
                                                                this.hideItemEditOpen(e);
                                                            }}>Cancel</button>
                                                        </div>
                                                    </div>
                                                </form>
                                    }
                                </div>
                            </div>
                        </div>
                    </Modal>

                    <Modal isOpen={this.state.menuItemModalDelIsOpen}
                        onRequestClose={() => this.setState({ menuItemModalDelIsOpen: false })}
                        style={modalStyles}
                        contentLabel="Delete Menu Item"
                        ariaHideApp={false}>
                        <div className="modal-header">
                            <h4 className="modal-title modal-title-color" id="deleteLabel">{this.props.type === "MENU" ? 'Delete menu item' : 'Delete breakfast menu item'}</h4>
                        </div>
                        <div className="modal-body">
                            {
                                this.props.type === "MENU" ?
                                    <p>Are you sure, you want to delete the selected menu item? If yes then all the existing order's associated to this menu will update to remove this item from order list. </p>
                                    :
                                    <p>Are you sure, you want to delete the selected breakfast menu item?</p>
                            }

                        </div>
                        <div className="text-right">
                            <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                                onClick={() => this.setState({ menuItemModalDelIsOpen: false })}><i
                                    className="glyphicon glyphicon-remove"
                                    style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                            </button>
                            <button type="button" className="btn btn-success btn-xs"
                                style={{ margin: '0 0 0 5px' }} onClick={() => {
                                    this.setState({ menuItemModalDelIsOpen: false, showReasonModal: true })
                                }}
                                id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Ok
                            </button>
                        </div>

                    </Modal>

                    <Modal isOpen={this.state.showReasonModal}
                        onRequestClose={() => this.setState({ showReasonModal: false })}
                        style={modalStyles}
                        contentLabel="Delete Menu Item Reason"
                        ariaHideApp={false}>
                        <div className="modal-header">
                            <h4 className="modal-title modal-title-color" id="deleteLabel">
                                {
                                    this.props.type === "MENU" ? "Delete menu item reason" : "Delete breakfast menu item reason"}</h4>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <form >
                                    <div className="col-sm-12 col-md-12">
                                        <div className="form-group">
                                            <label className="control-label" htmlFor="county">Reason *</label>
                                            <input type="text" name="reason"
                                                className="form-control border-color-1 rounded" id="reason" value={this.state.selectedMIdForDel.reason}
                                                placeholder="" onChange={(e) => { this.handleOnChangeReason(e); }}
                                                required />
                                        </div>
                                    </div>
                                    <div className="text-right">
                                        <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                                            onClick={() => this.setState({ showReasonModal: false })}><i
                                                className="glyphicon glyphicon-remove"
                                                style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                                        </button>
                                        <CustomSubmit type="button" className="btn btn-success btn-xs"
                                            style={{ margin: '0 0 0 5px' }}
                                            id="deleteConfirm" handleSubmit={(e, callback) => this.onSubmitForDel(e, callback)} >
                                            <i className="glyphicon glyphicon-ok"></i> Ok
                                        </CustomSubmit>
                                    </div>
                                </form>
                            </div>
                        </div>

                    </Modal>
                </div>
            )
        }
    }
}

ManageExtraItemCal.contextTypes = {
    router: PropTypes.object.isRequired
}
export default ManageExtraItemCal




// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Menu/managaExtraItemCal.jsx